module.exports = __webpack_public_path__ + "static/media/WBPhome.68bdd7eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/pics/WBPhome.png
// module id = 27
// module chunks = 0